class MessageUtil {
    public static REGISTRO_SALVO_SUCESS = 'Registro salvo com sucesso!';
    public static REGISTRO_ATUALIZADO_SUCESS = 'Registro atualizado com sucesso!';
    public static ERROR_SALVAR_REGISTRO = 'Falha ao salvar registro.';
    public static CAMPOS_OBRIGATORIOS = 'Favor preencher os campos obrigatórios!';
    public static ERROR_BUSCAR_REGISTRO = 'Falha ao buscar o registro.';
    public static ERROR_LISTAR_INFORMACAO = 'Falha ao listar informações!';
    public static CARREGANDO_TELA = 'Carregando...';
    public static CONFIRMAR_EXCLUSAO = 'Deseja excluir o registro?';
    public static REGISTRO_DELETED_SUCESS = 'Registro excluído com sucesso!';
    public static ERROR_DELETE_REGISTRO = 'Falha ao excluir registro.';
    public static CPF_INVALIDO = 'Favor informar um CPF válido!';
    public static ERROR_REMOVER_REGISTRO_REFERENCIADO = 'Está informação não pode ser excluída, pois está vinculada a outro registro.';
    public static ERROR_VALOR_MINIMO_MAIOR_VALOR_MAXIMO = 'O valor mínimo não pode ser maior que o valor máximo';
    public static CNPJ_INVALIDO = 'Favor informar um CNPJ válido!';
    public static EMAIL_INVALIDO = 'Favor informar um E-mail válido!';
    public static DATA_INICIO_MAIOR_TERMINO = 'A data de início não pode ser maior que a data de término.';
    public static ERROR_NUMERO_NEGATIVO = 'Não é permitido salvar números negativos.';
    public static GERANDO_RELATORIO = 'Gerando relatório...';
    public static GERANDO_IMPRESSAO_RELATORIO = 'Gerando impressão do relatório...';
    public static ERRO_EXPORTAR_ARQUIVO = 'Falha ao exportar arquivo.';
    public static ERRO_IMPRIMIR_ARQUIVO = 'Falha ao imprimir arquivo.';
    public static EXCLUINDO_REGISTRO = 'Excluindo...';
    public static FAVORECIDO_EXISTENTE = 'Favorecido já adicionado!';
    public static FAVORECIDO_REQUERIDO = 'Adicione um favorecido.';
    public static FASE_AVANCADA_SUCESSO = 'Fase avançada com sucesso!';
    public static ERROR_AVANCAR_FASE = 'Falha ao avançar de fase para este projeto!';
    public static RETORNAR_FASE_SUCESSO = 'Fase retornada com sucesso!';
    public static RETORNAR_FASE_ERROR = 'Falha ao retornar a fase deste projeto!';
    public static PROJETO_INATIVO_SUCESSO = 'Projeto inativado com sucesso!';
    public static PROJETO_INATIVO_ERROR = 'Falha ao inativar um projeto!';
    public static PROJETO_ATIVO_SUCESSO = 'Projeto ativado com sucesso!';
    public static PROJETO_ATIVO_ERROR = 'Falha ao ativar um projeto!';
    public static CANCELAR_PROJETO_SUCESSO = 'Projeto cancelado com sucesso!';
    public static CANCELAR_PROJETO_ERROR = 'Falha ao cancelar um projeto!';
    public static REGISTRO_ATIVADO_SUCESS = 'Registro ativado com sucesso!';
    public static REGISTRO_DESATIVADO_SUCESS = 'Registro desativado com sucesso!';
    public static REGISTRO_ATIVADO_ERROR = 'Falha ao ativar registro.';
    public static REGISTRO_DESATIVADO_ERROR = 'Falha ao desativar registro.';
    public static ERROR_UPDATE_REGISTRO = 'Falha ao atualizar registro.';
    public static SALVANDO_REGISTRO = 'Salvando Registro';
    public static ERROR_ALERTA_SEM_DESTINATARIO = 'Nenhum destinatário definido para este Alerta!';
    public static REGISTRO_DUPLICADO = 'Registro já existe!';
    public static REGISTRO_NAO_ENCONTRADO = 'Registro não encontrado!';
    public static ACAO_CANCELADA_SUCESSO = 'Ação cancelada com sucesso!';
    public static ACAO_REATIVADA_SUCESSO = 'Ação reativada com sucesso!';
    public static PERCENTUAL_MINIMO_PARTICIPACAO = 'O percentual mínimo da contribuição é de 3%';
    public static VALOR_MINIMO_APORTE = 'O valor mínimo para a contribuição é de duas UBRs, equivalente a R$ 250,56.';
    public static CPF_BENEFICIARIO_EXISTENTE = 'Já existe um beneficiário com o mesmo CPF!';
    public static DATA_NASCIMENTO_INVALIDA = 'Data de nascimento inválida!';
    public static BENEFICIARIO_OBRIGATORIO = 'Ao menos um beneficiário deve ser cadastrado!';
    public static ERROR_SENHA_LOGIN = 'Senha ou login incorretos.';
    public static FECHANDO_FOLHA = 'Fechando Folha!';
    public static FECHAMENTO_CONCLUIDO = 'Fechamento Concluído!';
    public static ABERTURA_FOLHA = 'Abertura da Folha!';
    public static ABERTURA_CONCLUIDA = 'Abertura Concluída!';
    public static CALCULO_CONCLUIDO = 'Calculo concluído com sucesso!';
    public static CALCULO_ERROR = 'Falha ao calcular!';
    public static TOKEN_SUCESSO = 'Token enviado!';
    public static TOKEN_FALHA = 'Falha ao enviar o token!';
    public static TOKEN_EXPIRADO = 'Token expirado!';
    public static ACESSO_SUCESSO = 'Acesso realizado com sucesso!';
    public static ACESSO_NEGADO = 'Acesso negado!';
    public static DADOS_ENCONTRADOS = 'Dados encontrados!';
    public static DADOS_NAO_ENCONTRADOS = 'Dados não encontrados.';
    public static REGISTRO_JA_INSERIDO = 'Registro já inserido!';
    public static REGISTRO_CARREGADO_SUCESS = 'Registro carregado com sucesso!';
    public static CREDENCIAS_INVALIDAS = 'Credenciais inválidas!';
    public static CREDENCIAS_SALVAS = 'Credenciais salvas com sucesso!';
    public static TOKEN_INVALIDO = 'Token inválido!';
    public static TOKEN_ENVIADO = 'Token enviado!';
    public static TOKEN_ENVIO = 'Informe seu E-mail ou número de telefone!';
    public static SISTEMA_NAO_ASSOCIADO = 'Você ainda não esta vinculado a esse sistema!';
}

export { MessageUtil }



// WEBPACK FOOTER //
// /usr/src/app/src/app/area-restrita/shared/messages/messageUtil.ts